import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1
    },
    header: {
        background: '#42474E'
    },
    title: {
        flexGrow: 1,
    }
}));

export default useStyles;